{
  "home.cards.empty": "Inga kort att visa just nu.",
  "home.cards.errorState": "Korten kunde inte laddas.",
  "home.cards.loading": "Laddar kort…",
  "home.feedback.close": "Stäng",
  "home.feedback.error": "Det gick inte att skicka din respons. Försök igen.",
  "home.feedback.description": "Ge ett betyg och skriv fri respons",
  "home.feedback.edgeMax": "Mycket nöjd",
  "home.feedback.edgeMin": "Mycket missnöjd",
  "home.feedback.label": "Respons",
  "home.feedback.legend": "Välj ett betyg 1–5",
  "home.feedback.ratingLabel": "Betyg {n}",
  "home.feedback.submit": "Skicka",
  "home.feedback.submitPending": "Skickar…",
  "home.feedback.success": "Tack för din respons",
  "home.feedback.textareaLabel": "Fri respons",
  "home.feedback.textareaPlaceholder": "Med din respons hjälper du oss att förbättra våra tjänster",
  "home.feedback.title": "Ge respons",
  "home.greeting.anonymous": "Välkommen",
  "home.greeting.day": "God dag,",
  "home.greeting.evening": "God kväll,",
  "home.greeting.morning": "God morgon,",
  "home.overdueFee.title": "Din medlemsavgift har förfallit",
  "home.overdueFee.body": "Din medlemsavgift är fortfarande obetald fast förfallodagen har passerat. Om du redan har betalat kan det ta några bankdagar innan betalningen registreras.",
  "home.overdueFee.action": "Gå till medlemsavgiften",
  "home.quickAccess.contact.subtitle": "Frågor om arbete eller lön? Frågor om medlemskap?",
  "home.quickAccess.contact.title": "Kontakta oss",
  "home.quickAccess.deferredBadge": "Kommer snart",
  "home.quickAccess.lakiruutu.subtitle": "Lakiruutu-videor med juridisk vägledning i arbetsfrågor",
  "home.quickAccess.lakiruutu.title": "Lakiruutu till din tjänst",
  "home.quickAccess.tools.subtitle": "Praktiska verktyg och räknare till ditt förfogande",
  "home.quickAccess.tools.title": "Verktyg och räknare",
  "home.tabs.label": "Startsidesavsnitt",
  "home.tabs.lakikaveri": "Lakikaveri",
  "home.tabs.palvelutEdut": "Medlemskap och förmåner"
}
